
<header class="bg-image bg-image-sec">
    <nav class="navbar navbar-expand-lg navbar-light fixed-top bg-white shadow-sm">
        <div class="container">
            <a class="navbar-brand" routerLink="/">
                <!-- <img src="../../../../assets/images/header-logo.png" /> -->
                <img src="../../../assets/images/enl-solutions-logo-new.png" class="enl-logo"/>
            </a>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav ml-auto"></ul>
                <div class="form-inline my-2 my-lg-0">
                </div>
            </div>
        </div>
    </nav>
</header>

<section class="login-section">
    <div class="login-section-inner">
        <div class="login-left">
            <h2>Hello!</h2>
            <div class="login-acc">
                Please complete to reset your Password.
            </div>
        </div>
        <div class="login-right">
            <div>
                <form class="form-card" [formGroup]="resetForm">
                    <div class="row">
                        <div class="col-md-12">
                            <!-- <img src="../../../../assets/images/innerLogo.png" class="login-logo" /> -->
                            <img src="../../../assets/images/enl-solutions-logo-new.png"  class="enl-logo"/>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <div class="section-relative">
                                    <input id="exampleInputPassword1" formControlName="newPassword" class="form-control" (keyup)="checkPasswords()"
                                        title="Passwords must contain at least eight characters." placeholder="New Password"
                                        type="password" required />
                                    <img src="../../../../assets/images/password.svg" class="user-icon pass-icon" />

                                    <div *ngIf="hasError('newPassword', 'required') && submitted"
                                        class="invalid-Validation">
                                        New Password is required
                                    </div>
                                    <div *ngIf="hasError('newPassword', 'pattern') && submitted"
                                        class="invalid-Validation">
                                        Passwords must contain at least eight characters.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <div class="section-relative">
                                    <input id="exampleInputPassword1" formControlName="confirmPassword" (keyup)="checkPasswords()"
                                        class="form-control" title="Passwords must contain at least eight characters." placeholder="Confirm Password"
                                        type="password" required />
                                    <img src="../../../../assets/images/password.svg" class="user-icon pass-icon" />

                                    <div *ngIf="hasError('confirmPassword', 'required') && submitted"
                                        class="invalid-Validation">
                                        Confirm Password is required
                                    </div>
                                    <div *ngIf="confirmPassNotSame" class="invalid-Validation">
                                        Confirm Password not match with password
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="btn-login-sec">
                                <button class="btn btn-signIn" type="submit" (click)="resetPassword()">
                                    Reset Password
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</section>